module.exports = __webpack_public_path__ + "img/gun_1.e6a39e21.png";